import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="w-full px-4 md:px-8 py-24">
      <div className="max-w-2xl mx-auto text-center">
        <p className="font-heading font-black text-[5rem] md:text-[8rem] leading-none text-background-200 select-none">
          404
        </p>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
          这个瓜没找到
        </h1>
        <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
          页面可能已经下线或者链接有误。当前路径：
          <span className="ml-1 text-foreground-800 break-all">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/breaking"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            去看今日爆料
          </Link>
        </div>
      </div>
    </section>
  );
}